import React from 'react';
import cn from 'classnames';
import { Modal, Tabs } from '@kaleyra/emmy';
import { TabItemPropsType } from '@kaleyra/emmy/dist/atoms/TabItem';

import Styles from './index.module.scss';

export type BaseSeeMorePropsType = {
	visible: boolean;
	onClose: () => void;
};

type SeeMoreModalPropsType = BaseSeeMorePropsType & {
	title?: string;
	// using header as the header and widget are almost same..
	header?: React.ReactNode;
	tabs?: Array<Omit<TabItemPropsType, 'isActive' | 'onClick'>>;
	parentTab?: string;
	getBody?: (currentTab: string) => React.ReactNode;
	onTabClick?: (currentTab: string) => void;
};

const SeeMoreModal: React.FC<SeeMoreModalPropsType> = ({
	visible,
	tabs = [],
	header,
	parentTab,
	onClose,
	getBody,
	onTabClick,
}) => {
	const [currentTab, setActiveTab] = React.useState<string>(
		tabs?.length ? (tabs[0].value as string) : ''
	);

	React.useEffect(() => {
		if (parentTab) {
			setActiveTab(parentTab);
		}
	}, [parentTab]);

	const onSelectTab = (tab: string) => {
		setActiveTab(tab);
		if (onTabClick) {
			onTabClick(tab);
		}
	};

	const getTitle = (): React.ReactNode => {
		return (
			<div className={Styles.title}>
				{header}
				<Tabs
					items={tabs}
					onClick={onSelectTab}
					currentActive={currentTab}
				/>
			</div>
		);
	};

	return (
		<Modal
			visible={visible}
			title={getTitle()}
			body={getBody && getBody(currentTab)}
			onClose={onClose}
			type={'fullscreen'}
			headerClass={cn(tabs.length ? Styles.seeMoreHeader : '')}
		/>
	);
};

export default SeeMoreModal;
